import { matchPath } from "react-router-dom";
import { t } from "../../i18n";
import { PageContext, PageEntityType } from "../../services/ChatService";
import { ENTITY_ID_PATTERN, ENTITY_ROUTES } from "./entityRoutes";

// Some routes reuse the :id position for non-entity screens, e.g. /admin/admin-user/new.
const SENTINEL_IDS = new Set(["new", "create", "edit", "list"]);

/*
 * Reverse of the assistant's ID→link vocabulary: maps the detail-page route the admin is
 * currently viewing back to the entity it shows, so the chat can send it as page context.
 * Matching is exact per pattern, so segment counts keep the entries from colliding.
 */
export function getPageContext(pathname: string): PageContext | null {
  for (const route of ENTITY_ROUTES) {
    const match = matchPath<{ id: string }>(pathname, { path: route.path, exact: true });
    if (match) {
      const id = match.params.id;
      return !SENTINEL_IDS.has(id) && ENTITY_ID_PATTERN.test(id) ? { entityType: route.entityType, entityId: id } : null;
    }
  }
  return null;
}

const ENTITY_LABELS: Record<PageEntityType, { key: string; fallback: string }> = {
  user: { key: "ai-chat.entity.user", fallback: "user" },
  account: { key: "ai-chat.entity.account", fallback: "account" },
  transaction: { key: "ai-chat.entity.transaction", fallback: "transaction" },
  payment: { key: "ai-chat.entity.payment", fallback: "payment" },
  "admin-user": { key: "ai-chat.entity.admin-user", fallback: "admin user" },
  "user-bonus": { key: "ai-chat.entity.user-bonus", fallback: "player bonus" },
  "bonus-config": { key: "ai-chat.entity.bonus-config", fallback: "bonus configuration" },
  "casino-game": { key: "ai-chat.entity.casino-game", fallback: "casino game" },
};

export function entityLabel(entityType: PageEntityType): string {
  const label = ENTITY_LABELS[entityType];
  return t(label.key, undefined, label.fallback);
}
